<!-- Copyright: J.B. Procter -->

<template>
  <!--
    <div style="width:270px;height:180px;">
    -->

  <img :src="`${img}`" style="position: absolute; z-index: 1; width: 270px; height: 180px" />

  <video
    playsinline="true"
    autoplay="true"
    loop="infinite"
    style="position: relative; width: 270px; height: 180px">
    <source :src="`${video}`" type="video/mp4" />
  </video>
  <!--
  </div>
  -->
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
const props = defineProps(["img", "video"]); // eslint-disable-line
</script>

<style scoped>
/* scoped = CSS limit to this component only */
figure {
  margin: 0px;
}
img {
  margin: auto;
  width: 100%;
}
figcaption {
  margin-top: 8px;
  font-size: 13px;
  font-weight: 300;
  margin-bottom: 8px;
}
small {
  display: inline; /* Makes the element inline with block capabilities */
}
small.credit {
  margin-left: 0.5rem; /* Pushes the credit to the right */
}
hr {
  color: var(--border-color-subtle); /* Legacy browsers */
  background-color: var(--border-color-subtle); /* Most browsers */
  border: none;
  height: 0.5px;
}
br,
hr {
  clear: both; /* clear float */
}
</style>
